import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PersonDetails.css";

function PersonDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const person = location.state; // Get the person data from state
  useEffect(() => {
    // Set body background to white when this page is loaded
    document.body.style.backgroundColor = "white";

    // Clean up by resetting the body background when leaving the page
    return () => {
      document.body.style.backgroundColor = ""; // Reset the body background color
    };
  }, []);
  if (!person) return <p>Person not found!</p>;

  const handleNavigateToAbout = () => {
    navigate("/about", {
      state: { scrollToSection: "person-section" }, // Pass section ID in state
    });
  };

  return (
    <div className="person-details-container">
      <div className="name-and-close">
        <h2 className="persondetails-name">{person.name}</h2>
        <button className="back-button" onClick={handleNavigateToAbout}>
          <i className="bi bi-x"></i> {/* Bootstrap Icons "X" icon */}
        </button>
      </div>
      <div className="person-details-card">
        <div className="persondetails-firstsection">
          <div className="persondetails-image">
            <img
              src={process.env.REACT_APP_BACKEND_URL_IMAGES + person.imageUrl}
              alt={person.name}
            />
          </div>

          <p className="persondetails-poisition">{person.position}</p>
        </div>

        <div className="persondetails-description">
          <div className="description-section">
            <p
              dangerouslySetInnerHTML={{
                __html: person.description
                  .split("</p><p><br></p><p>")
                  .slice(0, 3)
                  .join("</p><p><br></p><p>"),
              }}
            ></p>
          </div>
          <div className="description-section">
            <p
              dangerouslySetInnerHTML={{
                __html: person.description
                  .split("</p><p><br></p><p>")
                  .slice(3)
                  .join("</p><p><br></p><p>"),
              }}
            ></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersonDetails;
